const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_fGMgyo24B',
  aws_user_pools_web_client_id: '7t2pq22kelc5l1gnadu6ljmddq',
  aws_appsync_dangerously_connect_to_http_endpoint_for_testing: false,
};

export default awsmobile;
